import React from "react";

export const DataIntegrationMonitoring = React.lazy(
  () =>
    import("@/features/data-integration-monitoring/pages/DataIntegrationMonitoring.tsx"),
);
